var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KeepAlive',{attrs:{"include":"DefaultLayout"}},[_c(_vm.layout,{tag:"component",on:{"print":_vm.onPrint}},[_c(_vm.reportComponent,{tag:"component",attrs:{"reportResponse":_vm.reportResponse},on:{"load-report":function($event){return _vm.loadReport()}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }